/**
 * Module dependencies.
 */

import { ComponentType, ReactElement, ReactNode } from 'react';
import {
  StateDelay,
  useAnimationDelayItem,
} from 'components/providers/animation-delay-provider/animation-delay-provider';

/**
 * `CommonProps` type.
 */

type CommonProps = {
  className?: string;
  delay?: number;
  style?: any;
  threshold?: number;
};

/**
 * `WithRenderProp` type.
 */

type WithRenderProp = CommonProps & {
  animation?: undefined;
  children: (stateDelay: StateDelay) => ReactNode;
};

/**
 * `AnimationProps` type.
 */

export type AnimationProps = {
  children: ReactNode;
  stateDelay: StateDelay;
};

/**
 * `WithAnimationWrapper` type.
 */

type WithAnimationWrapper = CommonProps & {
  AnimationComponent: ComponentType<AnimationProps>;
  children: ReactNode;
};

/**
 * `InViewOnceProps` type.
 */

type InViewOnceProps = WithRenderProp | WithAnimationWrapper;

/**
 * `InViewOnce` component.
 */

export function InViewOnce(props: InViewOnceProps): ReactElement {
  const { className, delay, style, ...rest } = props;
  const { ref, stateDelay } = useAnimationDelayItem(delay);

  return (
    <div className={className} ref={ref as any} style={style}>
      {'AnimationComponent' in rest ? (
        <rest.AnimationComponent stateDelay={stateDelay}>
          {rest.children}
        </rest.AnimationComponent>
      ) : (
        rest.children(stateDelay)
      )}
    </div>
  );
}
